import * as Types from "../constants/ActionTypes";
import { ICouncil } from 'src/interfaces';

export const fetchCouncils = (councils: any[]) => ({
  payload: { councils },
  type: Types.FETCH_COUNCILS
});

export const fetchYears = (years: string[]) => ({
  payload: { years },
  type: Types.FETCH_YEARS
});

export const setCouncils = (councils: ICouncil[]) => ({
  payload: { councils },
  type: Types.SET_COUNCILS
});

export const toggleJumpTo = (whoOpened: string|null) => ({
  payload: {},
  type: (whoOpened === "JUMPTO" ? Types.NONE : Types.JUMPTO)
});

export const close = () => ({
  payload: {},
  type: null
});

export const actionByLabel = (label: string, section: string, year?: string) => ({
  payload: {
    year,
    section
  },
  type: (label.replace(/\s/g, '').toUpperCase())
})


// WEBPACK FOOTER //
// ./src/actions/index.ts